import * as Yup from "yup";
import { transformSnakeToCamel, transformModelToJson } from "utils/transform";
import { PaginationSchema } from "model/_common";
import { LinkSchema } from "model/_base/link";
import { ProductSchema } from "model/_base/products";
import { CampaignMiniSchema } from "model/_base/campaigns";
import { StatsSchema } from "model/_base/stats";

export const DataSchema = LinkSchema.clone()
  .transform(transformSnakeToCamel)
  .shape({
    product: ProductSchema.nullable(),
    campaign: CampaignMiniSchema.nullable().default(null),
    stats: StatsSchema.nullable(),
  });

export const LinksSchema = Yup.object().shape({
  data: Yup.array().of(DataSchema).nullable(),
  pagination: PaginationSchema,
});

export default class LinksModel {
  /**
   * Transform json to model
   * @param {object} json - JSON data to transform
   * @returns {object} Transformed model
   */
  static jsonToModel(json) {
    try {
      const model = LinksSchema.cast(json, {
        abortEarly: false,
        stripUnknown: true,
      });
      return model;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Transform model to json
   * @param {object} model - Model to transform
   * @returns {object} Transformed JSON
   */
  static modelToJson(model) {
    return transformModelToJson(model);
  }
}
